import {useQuery, useQueryClient} from 'react-query';
import {getCooperationAgreementDate} from './getCooperationAgreementDate';
import {IGetCooperationAgreementDateResponse} from './types';

const useGetCooperationAgreementDate = () => {
  const queryClient = useQueryClient();

  const {data, isLoading, refetch} =
    useQuery<IGetCooperationAgreementDateResponse>(
      ['get-cooperation-agreement-date'],
      () => getCooperationAgreementDate(),
      {
        onSuccess: () => {
          queryClient.invalidateQueries(['get-cooperation-agreement-status']);
        },
      },
    );

  return {data, isLoading, refetch};
};

export default useGetCooperationAgreementDate;
